var map = {
  "./api-manage.js": "48031",
  "./demo.js": "78004",
  "./logistics/common.js": "3326",
  "./logistics/picking/base.js": "24810",
  "./logistics/picking/exWarehouse.js": "21999",
  "./logistics/picking/order.js": "77835",
  "./logistics/picking/putInStorage.js": "59368",
  "./logistics/picking/receipt.js": "69167",
  "./logistics/picking/shipments.js": "76036",
  "./logistics/quality.js": "51222",
  "./logistics/reservoir_area.js": "10420",
  "./logistics/store_keeper.js": "63207",
  "./logistics/transport.js": "21378",
  "./logistics/warehousing.js": "19351",
  "./sale_shipments.js": "38340",
  "./service/engine/policy.js": "30398",
  "./service/engine/rule.js": "86238",
  "./service/manage/menu.js": "66360",
  "./shop/ruleSet.js": "10878"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 33280;
